module.exports = __webpack_public_path__ + "img/electricMotorcycle-grey.d1bc3334.svg";